import React from 'react';
export default function OkButton(_ref) {
  var prefixCls = _ref.prefixCls,
      locale = _ref.locale,
      okDisabled = _ref.okDisabled,
      onOk = _ref.onOk;
  var className = prefixCls + "-ok-btn";

  if (okDisabled) {
    className += " " + prefixCls + "-ok-btn-disabled";
  }

  return /*#__PURE__*/React.createElement("a", {
    className: className,
    role: "button",
    onClick: okDisabled ? null : onOk
  }, locale.ok);
}